const ALL_CITIES = "all";

function normalize(value) {
  return String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/[\s_]+/g, "-");
}

/**
 * @param {Array<string|{name?:string,city?:string,slug?:string}>} forWhichCity
 * @param {string} currentCity
 */
export function isCityAllowed(forWhichCity, currentCity) {
  // Not configured — don't restrict, keep existing content visible everywhere.
  if (!Array.isArray(forWhichCity) || forWhichCity.length === 0) return true;

  const normalizedList = forWhichCity.map((entry) =>
    normalize(
      typeof entry === "string"
        ? entry
        : entry?.name || entry?.city || entry?.slug,
    ),
  );

  if (normalizedList.includes(ALL_CITIES)) return true;

  return normalizedList.includes(normalize(currentCity));
}
